import React from "react";
import { Tooltip, Tag } from "antd";
import { SafetyCertificateOutlined } from "@ant-design/icons";

const TOOLTIP =
  "As a Preferred Vendor, you have priority dispatch and real-time market data for this job.";

/**
 * Shown on the public /bid/:token flow for vendors with vendor.isPreferred === true.
 */
export default function LeoVerifiedBidBadge() {
  return (
    <Tooltip title={TOOLTIP}>
      <Tag
        icon={<SafetyCertificateOutlined />}
        color="processing"
        style={{
          fontSize: "0.875rem",
          padding: "4px 10px",
          marginBottom: 0,
          borderRadius: 8,
        }}
      >
        Clumse AI Verified
      </Tag>
    </Tooltip>
  );
}
